import { Modal as BaseModal } from 'react-responsive-modal'

export const Modal = ({ children, ...props }) => <BaseModal {...props}>{children}</BaseModal>
